'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _web3Utils = require('web3-utils');

var _web3Utils2 = _interopRequireDefault(_web3Utils);

var _AddressImage = require('./AddressImage');

var _AddressImage2 = _interopRequireDefault(_AddressImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EthereumAddress = function EthereumAddress(_ref) {
  var address = _ref.address,
      className = _ref.className,
      showImage = _ref.showImage,
      imageBeforeAddress = _ref.imageBeforeAddress;
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    showImage && imageBeforeAddress && _react2.default.createElement(_AddressImage2.default, { address: address, className: 'address-image' }),
    _react2.default.createElement(
      'span',
      { className: className },
      _web3Utils2.default.toChecksumAddress(address)
    ),
    showImage && !imageBeforeAddress && _react2.default.createElement(_AddressImage2.default, { address: address, className: 'address-image' })
  );
};

EthereumAddress.displayName = 'EthereumAddress';

EthereumAddress.defaultProps = {
  className: 'address',
  showImage: true,
  imageBeforeAddress: false
};

EthereumAddress.propTypes = {
  address: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  showImage: _propTypes2.default.bool,
  imageBeforeAddress: _propTypes2.default.bool
};

exports.default = EthereumAddress;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/EthereumAddress.js
// module id = 277
// module chunks = 0